import React, { useCallback, useEffect, useMemo } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultPRD3010_R01Filter, PRD3010_R01Filter, usePRD3010_R01Store } from 'src/containers/mes/PRD/PRD3010_R01/Store_PRD3010_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { createPRD3010_R01LotNo, deletePRD3010_R01, downloadExcel_PRD3010_R01, getPdfBlob_PRD3010_R01, getPRD3010_R01AllCount, getPRD3010_R01LotList, getPRD3010_R01DowntimeList, getPRD3010_R01InspectList, getPRD3010_R01List, getPRD3010_R01ProductResultList, patchPRD3010_R01, postPRD3010_R01, getPRD3010_R01DetailList, getPRD3010_R01DetailStockList, getPRD3010_R01TransportedInfo, getPRD3010_R01One } from "./Api_PRD3010_R01";
import { defaultPRD3010_R01LotDto, defaultPRD3010_R01DowntimeDto, defaultPRD3010_R01HeaderDto, defaultPRD3010_R01InspectDto, PRD3010_R01LotDto, PRD3010_R01DowntimeDto, PRD3010_R01Dto, PRD3010_R01HeaderDto, PRD3010_R01InspectDto, PRD3010_R01ProductResultDto, defaultPRD3010_R01DetailDto, PRD3010_R01DetailDto } from './Dto_PRD3010_R01';
import { validateEditBadQtyAgainstInspectList } from './inspectBadQtyUtil_PRD3010_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { formatDate, toLocalDateTime, validateString } from 'src/utils/string/stringUtil';
import { validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { LabelPrintData } from 'src/apis/labelApi';
import { PRD3010_R01_extractUnprintedLabelData } from './labelDataBuilder_PRD3010_R01';
import { useQzPrint } from 'src/hooks/useQzPrint';
import { getDefaultLabelPrintAuto } from 'src/utils/label/labelPrintAutoProgramUtil';
import qz from 'qz-tray';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	PRD3010_R01_DOWNTIMEROW_VALIDATE,
	PRD3010_R01_HEADERROW_VALIDATE,
	PRD3010_R01_INSPECTROW_VALIDATE,
	PRD3010_R01_LOTROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { useWarehouseValidate } from 'src/utils/warehouse/WarehouseValidateContext';

interface Props {
	gridRef: React.RefObject<AgGridReact<PRD3010_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<PRD3010_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<PRD3010_R01DetailDto> | null>;
	inspectGridRef: React.RefObject<AgGridReact<PRD3010_R01InspectDto> | null>;
	downtimeGridRef: React.RefObject<AgGridReact<PRD3010_R01DowntimeDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_PRD3010_R01 = (props: Props) => {
	const { printBulkLabel, printPdfFromBlob } = useQzPrint();

	const {
		gridRef, lotGridRef, detailGridRef, inspectGridRef, downtimeGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { faultyValueList, downtimeValueList, itemStatusList, moneyCdList, vatTypeList, wmsCdList, compCdList, employeeCdList, workPlaceList, warehouseCdList, programList } = useCommonCodeStore();

	const defaultLabelPrintAuto = useMemo(
		() => getDefaultLabelPrintAuto(programList),
		[programList]
	);
	const {
		PRD3010_R01Filter, setPRD3010_R01Filter,
		PRD3010_R01PastFilter, setPRD3010_R01PastFilter,
		PRD3010_R01List, setPRD3010_R01List,
		editPRD3010_R01, setEditPRD3010_R01,
		selectedPRD3010_R01, setSelectedPRD3010_R01, 
		deletedPRD3010_R01LotList, setDeletedPRD3010_R01LotList, addDeletedPRD3010_R01LotList, removeDeletedPRD3010_R01LotList, 
		selectedPRD3010_R01LotList, setSelectedPRD3010_R01LotList, addSelectedPRD3010_R01LotList, removeSelectedPRD3010_R01LotList,
		PRD3010_R01LotList, setPRD3010_R01LotList, insertPRD3010_R01LotList,
		originalPRD3010_R01LotList, setOriginalPRD3010_R01LotList,
		deletedPRD3010_R01DetailList, setDeletedPRD3010_R01DetailList, addDeletedPRD3010_R01DetailList, removeDeletedPRD3010_R01DetailList, 
		selectedPRD3010_R01DetailList, setSelectedPRD3010_R01DetailList, addSelectedPRD3010_R01DetailList, removeSelectedPRD3010_R01DetailList,
		PRD3010_R01DetailList, setPRD3010_R01DetailList, insertPRD3010_R01DetailList,
		originalPRD3010_R01DetailList, setOriginalPRD3010_R01DetailList,
		PRD3010_R01InspectList, setPRD3010_R01InspectList, insertPRD3010_R01InspectList,
		deletedPRD3010_R01InspectList, setDeletedPRD3010_R01InspectList, addDeletedPRD3010_R01InspectList, removeDeletedPRD3010_R01InspectList,
		selectedPRD3010_R01InspectList, setSelectedPRD3010_R01InspectList, addSelectedPRD3010_R01InspectList, removeSelectedPRD3010_R01InspectList,
		originalPRD3010_R01InspectList, setOriginalPRD3010_R01InspectList,
		allCount, setAllCount,
		detailFetchTrigger, setDetailFetchTrigger,
		productResultComplete, setProductResultComplete,
		initData, 
		warehouseCdListToUseList, outWarehouseCdListToUseList, badWarehouseCdListToUseList,
		setScrollTop, setDetailScrollTop, setLotScrollTop, setInspectScrollTop,
	} = usePRD3010_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { validateWorkplaceWarehouse } = useWarehouseValidate();

	useFetchActionbarAuth("PRD3010_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedPRD3010_R01 || !selectedPRD3010_R01.productResultNo) {
				showWarning("출력할 생산실적번호를 선택하세요.");
				setMessage("출력할 생산실적번호를 선택하세요.");
				return;
			}
			setLoadingSpinner(true);
			try {
				const blob = await getPdfBlob_PRD3010_R01(selectedPRD3010_R01.productResultNo);
				if (qz.websocket.isActive()) {
					const ok = await printPdfFromBlob(blob, "report1");
					if (ok) {
						showSuccess("PDF 출력을 완료하였습니다.");
					} else {
						const fileURL = URL.createObjectURL(blob);
						window.open(fileURL, "_blank");
						setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					}
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
				}
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			} finally {
				setLoadingSpinner(false);
			}
	}, [selectedPRD3010_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedPRD3010_R01) {
			showWarning("선택된 생산실적내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_PRD3010_R01('', selectedPRD3010_R01.productResultNo, PRD3010_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '생산실적 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedPRD3010_R01])

	const getParams = (filter: PRD3010_R01Filter) => {
		const params: Partial<PRD3010_R01Filter> = {
			dateRange: filter.dateRange || undefined,
			compCd: filter.compCd || undefined,
			compNm: filter.compNm || undefined,
			workplaceCd: filter.workplaceCd || undefined,
			itemCd: filter.itemCd || undefined,
			itemNm: filter.itemNm || undefined,
			workEmp: filter.workEmp || undefined,
			workEmpNm: filter.workEmpNm || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getPRD3010_R01AllCount(getParams(PRD3010_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [PRD3010_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setDetailScrollTop(null);
		setLotScrollTop(null);
		setInspectScrollTop(null);
		setLoadingSpinner(true);		
	
		const responseData = (await getPRD3010_R01List(
			'',
			getParams(PRD3010_R01Filter),
			PRD3010_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as PRD3010_R01HeaderDto[];
		setPRD3010_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedPRD3010_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedPRD3010_R01?.salBillNo)
			);
			setPRD3010_R01PastFilter(PRD3010_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedPRD3010_R01(undefined);
			setPRD3010_R01List([]);
			setPRD3010_R01LotList([]); 
			setDeletedPRD3010_R01LotList([]);
			setSelectedPRD3010_R01LotList([]);
			setOriginalPRD3010_R01LotList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [PRD3010_R01Filter, PRD3010_R01List, setPRD3010_R01List, setPRD3010_R01PastFilter, setSelectedPRD3010_R01, selectedPRD3010_R01, setScrollTop, setDetailScrollTop, setLotScrollTop, setInspectScrollTop])

	const fetchOne = useCallback(async () => {
		if (!selectedPRD3010_R01) return;
		setLoadingSpinner(true);

		const response = await getPRD3010_R01One(selectedPRD3010_R01.productOrderNo);

		if(!response.data.data) {
			showWarning('조회된 데이터가 없습니다.');
			setLoadingSpinner(false);
			return undefined;
		}

		//입고, 출고, 불량창고 코드 검증
		const warehouseResult = validateWorkplaceWarehouse({
			mode: 'workplace',
			workPlaceList,
			warehouseCdList,
			wmsCdList,
			workplaceCd: selectedPRD3010_R01?.workplaceCd ?? workPlaceList[0].workplaceCd ?? '',
		});
		if (!warehouseResult.valid || warehouseResult.mode !== 'workplace') {
			setLoadingSpinner(false);
			return undefined;
		}
		const { logicCenter, inWarehouseCd, outWarehouseCd, badWarehouseCd } = warehouseResult;

		response.data.data.logicCenter = logicCenter || wmsCdList[0].minorCd;
		response.data.data.warehouseCd = validateString(response.data.data.warehouseCd) ? response.data.data.warehouseCd : inWarehouseCd[0].warehouseCd;
		response.data.data.outWarehouseCd = validateString(response.data.data.outWarehouseCd) ? response.data.data.outWarehouseCd : outWarehouseCd[0].warehouseCd;
		response.data.data.badWarehouseCd = validateString(response.data.data.badWarehouseCd) ? response.data.data.badWarehouseCd : badWarehouseCd[0].warehouseCd;

		setEditPRD3010_R01(response.data.data);

		setLoadingSpinner(false);
		return response.data.data as PRD3010_R01HeaderDto;
	}, [selectedPRD3010_R01, setEditPRD3010_R01, setLoadingSpinner, workPlaceList, wmsCdList, warehouseCdList, validateWorkplaceWarehouse])

	const defaultPRD3010_R01HeaderRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3010_R01_HEADERROW_VALIDATE, {
				compCdList,
				itemStatusList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultPRD3010_R01HeaderDto }; }

		const warehouseResult = validateWorkplaceWarehouse({
			mode: 'workplace',
			workPlaceList,
			warehouseCdList,
			wmsCdList,
			workplaceCd: workPlaceList[0]?.workplaceCd ?? '',
		});
		if (!warehouseResult.valid || warehouseResult.mode !== 'workplace') {
			return { ...defaultPRD3010_R01HeaderDto };
		}
		const { logicCenter: warehouseLogicCenter, inWarehouseCd, outWarehouseCd, badWarehouseCd } = warehouseResult;

		return {
			...defaultPRD3010_R01HeaderDto,
			compCd: compCdList[0].compCd,
			workplaceCd: workPlaceList[0].workplaceCd,
			logicCenter: warehouseLogicCenter,
			warehouseCd: inWarehouseCd[0].warehouseCd,
			outWarehouseCd: outWarehouseCd[0].warehouseCd,
			badWarehouseCd: badWarehouseCd[0].warehouseCd,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [
		defaultPRD3010_R01HeaderDto, compCdList, workPlaceList, itemStatusList,
		wmsCdList, warehouseCdList, validateCommonCodeLists, validateWorkplaceWarehouse,
	]);

	const defaultPRD3010_R01LotRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3010_R01_LOTROW_VALIDATE, {
				itemStatusList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultPRD3010_R01LotDto }; }

		return {
			...defaultPRD3010_R01LotDto,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [defaultPRD3010_R01LotDto, itemStatusList, validateCommonCodeLists]);

	const defaultPRD3010_R01DetailRow = useCallback(() => {
		return {
			...defaultPRD3010_R01DetailDto,
			inserted: true,
		};
	}, [defaultPRD3010_R01DetailDto]);

	const defaultPRD3010_R01DowntimeRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3010_R01_DOWNTIMEROW_VALIDATE, {
				downtimeValueList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultPRD3010_R01DowntimeDto }; }

		return {
			...defaultPRD3010_R01DowntimeDto,
			downtimeCase: downtimeValueList[0].minorCd,
			inserted: true,
		};
	}, [defaultPRD3010_R01DowntimeDto, downtimeValueList, validateCommonCodeLists]);

	const defaultPRD3010_R01InspectRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(PRD3010_R01_INSPECTROW_VALIDATE, {
				faultyValueList,
			}),
		);
		if (!commonResult.valid) { return { ...defaultPRD3010_R01InspectDto }; }

		return {
			...defaultPRD3010_R01InspectDto,
			badCase: faultyValueList[0].minorCd,
			inserted: true,
		};
	}, [defaultPRD3010_R01InspectDto, faultyValueList, validateCommonCodeLists]);
	
	const initContainerData = useCallback(() => {
		initData();
		setPRD3010_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
		removeDeletedPRD3010_R01LotList();
		removeSelectedPRD3010_R01LotList();
		setEditPRD3010_R01({ ...defaultPRD3010_R01HeaderRow() });
	}, [initData, defaultLabelPrintAuto, setPRD3010_R01Filter, removeDeletedPRD3010_R01LotList, removeSelectedPRD3010_R01LotList, setEditPRD3010_R01, defaultPRD3010_R01HeaderRow]);

	const handleDeleteClick = useCallback(() => {

		// 비가동 - 불량내역 삭제 기능으로 변경하기
		if (deletedPRD3010_R01InspectList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구

			removeDeletedPRD3010_R01InspectList(deletedPRD3010_R01InspectList);
			removeSelectedPRD3010_R01InspectList();
			setPRD3010_R01InspectList([...PRD3010_R01InspectList]);

		} else if (selectedPRD3010_R01InspectList.length > 0) {

			addDeletedPRD3010_R01InspectList(selectedPRD3010_R01InspectList);
			removeSelectedPRD3010_R01InspectList(selectedPRD3010_R01InspectList);
		}

	}, [
		selectedPRD3010_R01InspectList, deletedPRD3010_R01InspectList, setPRD3010_R01InspectList, PRD3010_R01InspectList,
	]);
	
	const handleCreateClick = () => {
		const headerRow = defaultPRD3010_R01HeaderRow();
		if (!headerRow.inserted) return;

		const inspectRow = defaultPRD3010_R01InspectRow();
		if (!inspectRow.inserted) return;

		setSelectedPRD3010_R01(undefined);
		setEditPRD3010_R01({ ...headerRow });

		setPRD3010_R01LotList([]);
		setDeletedPRD3010_R01LotList([]);
		setSelectedPRD3010_R01LotList([]);

		setPRD3010_R01InspectList([{ ...inspectRow }]);
		setDeletedPRD3010_R01InspectList([]);
		setSelectedPRD3010_R01InspectList([]);
		setOriginalPRD3010_R01InspectList([]);

		setDetailScrollTop(null);
		setLotScrollTop(null);
		setInspectScrollTop(null);
	};

	const getProductResultHeaderDto = (header: PRD3010_R01HeaderDto) => {
		return {
			...header,
			workStartDt: toLocalDateTime(new Date()),
			workEndDt: toLocalDateTime(new Date()),
			productEmp: header.orderEmp,
			productEmpNm: header.orderEmpNm,
			kpiYn: '',
			inspectQty: 0,
			inspectYn: 'N',
		} as PRD3010_R01ProductResultDto;
	}

	const validateInsertData = (
		header: PRD3010_R01HeaderDto,
		lotList: PRD3010_R01LotDto[],
		detailList: PRD3010_R01DetailDto[],
		inspectList: PRD3010_R01InspectDto[]
	) => {
		
		if (!validateString(header.compCd)) {
			showWarning('사업장을 선택해주세요.'); return false;
		}
		if (!validateString(header.workplaceCd)) {
			showWarning('공정명을 선택해주세요.'); return false;
		}
		if (!validateWorkplaceWarehouse({
			mode: 'workplace',
			workPlaceList,
			warehouseCdList,
			wmsCdList,
			workplaceCd: header.workplaceCd,
		}).valid) {
			return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('입고물류를 선택해주세요.'); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('입고창고를 선택해주세요.'); return false;
		}
		if (!validateString(header.orderEmp)) {
			showWarning('담당자를 입력해주세요.'); return false;
		}
		if (!validateEmployeeCd(header.orderEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		// if (header.productQty > header.orderQty) {
		// 	showWarning('양품수량(lot 작업지시량)은 생산실적수량보다 클 수 없습니다.'); return false;
		// }

		let activeLotList: PRD3010_R01LotDto[] = [];
 
		// Lot 항목 검증
		if (lotList.length > 0) {
			const deletedLotListToNumber = deletedPRD3010_R01LotList.map(value => Number(value));
			activeLotList = lotList.filter(detail => 
				!deletedLotListToNumber.includes(detail.valueIndex)
			);

			// 1. lotNo가 있는 항목들만 골라냅니다.
			const lotNos = activeLotList.map(detail => detail.lotNo).filter(lotNo => lotNo); // lotNo 가져오기
			const duplicates = lotNos.filter((lot, index) => lotNos.indexOf(lot) !== index);	// lotNo 중복 제거
			
			if (duplicates.length > 0) {
				showWarning("중복된 LOT No가 있습니다.\nLOT No: " + duplicates[0]);
				return false;
			}
		}

		const validateLotList = lotList.filter(detail => 
			detail.inserted === true && detail.lotQty > 0
		);
		const validateDetailList = detailList.filter(detail => 
			detail.isModified === true
		);
			
		//lot 입력행이나 자재출고 수정행이 없으면 반려
		if(validateLotList.length === 0 && validateDetailList.length === 0) {
			showWarning('Lot 입력행이나 자재출고 수정행을 입력해주세요. (최소 1개 이상 입력)'); return false;
		}


		//자재출고 검증
		if (detailList.length > 0) {
			for (const detail of detailList) {
				if (detail.transportQty > detail.lotQty) {
					showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`); return false;
				}
			}

			//childItemcd 기준으로 각 요소들을 분배해서 각 품목코드에 대한 출고량을 계산, 소요량과 비교해서 출고량이 소요량보다 클 수 없다
			// 현재는 수정해서 출고량이 소요량보다 높아도 되는데 롤백할 가능성이 있어서 코드를 보관함
			//
			const childItemcdList = detailList.map(detail => detail.childItemcd).filter(childItemcd => childItemcd);
			const uniqueChildItemcdList = Array.from(new Set(childItemcdList));
			for (const childItemcd of uniqueChildItemcdList) {
				const childItemcdDetailList = detailList.filter(detail => detail.childItemcd === childItemcd);
				const childItemcdTransportQty = childItemcdDetailList.reduce((sum, detail) => sum + detail.transportQty, 0);
				// if (childItemcdTransportQty > childItemcdDetailList[0].bomUsingQty) {
				// 	showWarning(`${childItemcd} 품목의 출고량은 소요량보다 클수 없습니다. `); return false;
				// }
			}
		}
		//불량수량 검증 (badCase별 badQty 합산 기준)
		if (inspectList.length > 0) {
			const deletedInspectListToNumber = deletedPRD3010_R01InspectList.map(value => Number(value));
			const badQtyValidation = validateEditBadQtyAgainstInspectList(
				header.badQty || 0,
				inspectList,
				deletedInspectListToNumber,
			);

			if (!badQtyValidation.valid) {
				showWarning(badQtyValidation.message!);
				return false;
			}
		}
		
		return true;
	}

	// 입고등록(WMS1020)과 동일: 저장 전 LOT 번호 미부여 행에 API로 발급
	const assignLotNoToLotList = useCallback(async (currentLotList: PRD3010_R01LotDto[]): Promise<PRD3010_R01LotDto[]> => {
		const newLotList = currentLotList.map(lot => ({ ...lot }));
		const promises: Promise<void>[] = [];
		newLotList.forEach((lot) => {
			if (!validateString(lot.lotNo)) {
				const promise = createPRD3010_R01LotNo().then((res) => {
					if (res.data?.successFlag && res.data?.data) {
						lot.lotNo = res.data.data;
					}
				});
				promises.push(promise);
			}
		});
		if (promises.length > 0) {
			await Promise.all(promises);
			setPRD3010_R01LotList(newLotList);
		}
		return newLotList;
	}, [setPRD3010_R01LotList]);
	
	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(editPRD3010_R01!, PRD3010_R01LotList, PRD3010_R01DetailList, PRD3010_R01InspectList)) valid = false;
		if(!valid) { return; }
		setLoadingSpinner(true);

		// STEP 0: 저장 전 LOT 번호 발급 (입고등록과 동일)
		const PRD3010_R01AssignedLotList = await assignLotNoToLotList(PRD3010_R01LotList);

		// STEP 1: 저장 전에 미출력 라벨 데이터만 추출 (Lot라벨자동출력=Y일 때만). 저장 완료 후 일괄 출력
		let unprintedLabelData: LabelPrintData[] = [];
		if (PRD3010_R01Filter.labelPrintAuto === 'Y') {
			unprintedLabelData = PRD3010_R01_extractUnprintedLabelData(
				{ editPRD3010_R01, PRD3010_R01DetailList, PRD3010_R01LotList: PRD3010_R01AssignedLotList },
				deletedPRD3010_R01LotList
			);
		}

		const deletedPRD3010_R01LotList_Number = deletedPRD3010_R01LotList.map(value => Number(value));
		let processName = '';
		let newHeaderList: PRD3010_R01HeaderDto[] = [];
		let newLotList: PRD3010_R01LotDto[] = [];
		let newInspectList: PRD3010_R01InspectDto[] = [];
		let newDowntimeList: PRD3010_R01DowntimeDto[] = [];
		let newDetailList: PRD3010_R01DetailDto[] = [];
		let responseData: PRD3010_R01Dto = {
			productOrderHeaderDto: editPRD3010_R01!,
			productResultHeaderDto: getProductResultHeaderDto(editPRD3010_R01!),
			wmsStockLotDtoList: PRD3010_R01AssignedLotList,
			bomDtoList: PRD3010_R01DetailList,
			prdInspectResultDtoList: PRD3010_R01InspectList
		};
		let deleteHeaderFlag = false;

		try {
			
		
			if (selectedPRD3010_R01) {
				newLotList = PRD3010_R01AssignedLotList.filter(value => 
					!deletedPRD3010_R01LotList_Number.includes(value.valueIndex)
				);

				if (newLotList.length === 0) {
					processName = 'delete';
					const deleteResponse = await deletePRD3010_R01(selectedPRD3010_R01.productOrderNo);

					newHeaderList = PRD3010_R01List.filter(value => value.productOrderNo !== selectedPRD3010_R01.productOrderNo);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('생산실적이 삭제 되었습니다.');
							setMessage('생산실적이 삭제 되었습니다.');
						}else return;
					}
				} else {
					processName = 'patch';

					const deletedPRD3010_R01InspectList_Number = deletedPRD3010_R01InspectList.map(value => Number(value));
					const patchResponse = await patchPRD3010_R01({
						productOrderHeaderDto: editPRD3010_R01!,
						productResultHeaderDto: getProductResultHeaderDto(editPRD3010_R01!),
						wmsStockLotDtoList: PRD3010_R01AssignedLotList.filter(value => (
							(value.lotQty > 0 && value.inserted === true)
							&& !deletedPRD3010_R01LotList_Number.includes(value.valueIndex)
						)),
						bomDtoList: PRD3010_R01DetailList,
						// 불량사유가 있는 항목만 전송
						prdInspectResultDtoList: PRD3010_R01InspectList.filter(value => (
								!deletedPRD3010_R01InspectList_Number.includes(value.valueIndex) 
								&& validateString(value.badCase)
							)
						),

					});

					responseData = patchResponse.data.data;
					// console.log('patchResponse :', patchResponse);
					

					const responseProductOrderHeaderDto = {
						...responseData.productOrderHeaderDto,
						//결과량, 지시량은 작업지시정보에 기록되어 있다
						resultQty: responseData.productOrderHeaderDto.resultQty,
					};

					newHeaderList = PRD3010_R01List.map(value => {
						if (value.productOrderNo === responseData.productOrderHeaderDto.productOrderNo) {
							return responseProductOrderHeaderDto;
						}
						return value;
					});
					//생산양품량이 작업지시량이랑 같거나 크면, 해당 header을 list에서 삭제
					if (editPRD3010_R01!.productQty >= editPRD3010_R01!.orderQty) {
						newHeaderList = PRD3010_R01List.filter(value => value.productOrderNo !== responseData.productOrderHeaderDto.productOrderNo);	
						deleteHeaderFlag = true;
					}
					
					if (patchResponse?.data?.data && patchResponse.data.successFlag) {

						showSuccess('생산실적이 등록 되었습니다.');
						setMessage('생산실적이 등록 되었습니다.');
					}else {
						showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
						setLoadingSpinner(false);
						return;
					}
				}
			} else {
				processName = 'post';
				const postResponse = await postPRD3010_R01({
					productOrderHeaderDto: editPRD3010_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editPRD3010_R01!),
					wmsStockLotDtoList: PRD3010_R01AssignedLotList,
					bomDtoList: PRD3010_R01DetailList,
					prdInspectResultDtoList: PRD3010_R01InspectList.filter(value => (
						validateString(value.badCase)
					)),
				});
				responseData = postResponse.data.data;

				const responseProductWorkHeaderDto = {
					...responseData.productOrderHeaderDto,
					resultQty: 0
				};

				newHeaderList = [
					...PRD3010_R01List,
					responseProductWorkHeaderDto,
				] as PRD3010_R01HeaderDto[];
				
				if (postResponse?.data?.data && postResponse.data.successFlag) {
					showSuccess('생산실적이 등록 되었습니다.');
					setMessage('생산실적이 등록 되었습니다.');
				}else {
					showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			}
		} catch (error) {
			console.error("생산실적 작업 중 오류가 발생했습니다.:", error);
			showError('생산실적 작업 중 오류가 발생했습니다.');
			setLoadingSpinner(false);
			return;
		}


		if (processName === 'delete' || deleteHeaderFlag) {
			setPRD3010_R01List(newHeaderList);

			setSelectedPRD3010_R01(undefined);
			setEditPRD3010_R01({ ...defaultPRD3010_R01HeaderRow() });
			setPRD3010_R01DetailList([]);
			setPRD3010_R01LotList([]);

			setSelectedPRD3010_R01DetailList([]);
			setSelectedPRD3010_R01LotList([]);

			setOriginalPRD3010_R01DetailList([]);
			setOriginalPRD3010_R01LotList([]);

			setDeletedPRD3010_R01DetailList([]);
			setDeletedPRD3010_R01LotList([]);

			deleteHeaderFlag = false;

			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setPRD3010_R01List(newHeaderList);
			setPRD3010_R01LotList([]);
			const lotRow = defaultPRD3010_R01LotRow();
			if (lotRow.inserted) {
				insertPRD3010_R01LotList([{ ...lotRow }]);
			}

			const newEditPRD3010_R01 = {
				...responseData.productOrderHeaderDto,
				...responseData.productResultHeaderDto,
				orderQty: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty,
				productQty: 0,
				badQty: 0,
				orderEmp: responseData.productResultHeaderDto.productEmp,
				orderEmpNm: responseData.productResultHeaderDto.productEmpNm,
			};

			setEditPRD3010_R01(newEditPRD3010_R01);
			setOriginalPRD3010_R01LotList(responseData.wmsStockLotDtoList);

			//기존 bomDetailList에서 responseData.bomDtoList에 존재하는 lotno, itemno인 행만 가져옴
			//  responseData.bomDtoList를 적용
			const newDetailList = PRD3010_R01DetailList.filter(
				value => responseData.bomDtoList.some(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				)
			).map(value => ({ 
				...value, 
				...responseData.bomDtoList.find(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				),
				childItemUsage: value.childItemUsage, 
				bomUsingQty: 0, 
				transportQty: 0, 
				isModified: false,
			}));
			setPRD3010_R01DetailList(newDetailList);
			setOriginalPRD3010_R01DetailList(newDetailList);
		}
		
		const inspectRow = defaultPRD3010_R01InspectRow();
		if (inspectRow.inserted) {
			setPRD3010_R01InspectList([{ ...inspectRow }]);
		} else {
			setPRD3010_R01InspectList([]);
		}
		setSelectedPRD3010_R01InspectList([]);
		setOriginalPRD3010_R01InspectList([]);
		setDeletedPRD3010_R01InspectList([]);

		// setSelectedPRD3010_R01(undefined);
		setDeletedPRD3010_R01LotList([]);
		setSelectedPRD3010_R01LotList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000);
		setLoadingSpinner(false);

		// 저장 완료 후 미출력 라벨 일괄 출력 (Lot라벨자동출력=Y, 삭제/헤더삭제가 아닐 때만. WMS1020와 동일 흐름)
		if (
			PRD3010_R01Filter.labelPrintAuto === 'Y' &&
			unprintedLabelData.length > 0 &&
			processName !== 'delete' &&
			!deleteHeaderFlag
		) {
			try {
				const ok = await printBulkLabel(unprintedLabelData, 'label1');
				if (ok) {
					showSuccess(`저장 완료! ${unprintedLabelData.length}개 라벨 출력`);       
				} else {
					showWarning('저장은 완료되었으나 라벨 출력에 실패했습니다. 프린터 설정을 확인해주세요.');
				}
			} catch (error: any) {
				console.error('라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${error?.message || '알 수 없는 오류'}`);
				setLoadingSpinner(false);
			}
		}
	}, [
		PRD3010_R01Filter,
		PRD3010_R01List, setPRD3010_R01List,
		editPRD3010_R01,
		selectedPRD3010_R01,
		PRD3010_R01LotList, setPRD3010_R01LotList,
		PRD3010_R01DetailList, setPRD3010_R01DetailList,
		PRD3010_R01InspectList, setPRD3010_R01InspectList, deletedPRD3010_R01InspectList,
		deletedPRD3010_R01LotList,
		assignLotNoToLotList,
		printBulkLabel,
		setLoadingSpinner,
		defaultPRD3010_R01HeaderRow, defaultPRD3010_R01LotRow, defaultPRD3010_R01InspectRow, defaultPRD3010_R01DowntimeRow,
		handleCreateClick,
	])

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleProductResultInfoCode = useCallback((headerData: PRD3010_R01HeaderDto): Partial<PRD3010_R01HeaderDto> => {
		const defaults: Partial<PRD3010_R01HeaderDto> = {};

		//날짜를 당일로 초기화
		defaults.productDt = formatDate(new Date());
				
		if(!validateString(headerData.compCd) && compCdList.length > 0)				defaults.compCd = compCdList[0].compCd;
		if(!validateString(headerData.workplaceCd) && workPlaceList.length > 0)		defaults.workplaceCd = workPlaceList[0].workplaceCd;

		if(!validateString(headerData.logicCenter) && wmsCdList.length > 0)			{
			defaults.logicCenter = wmsCdList[0].minorCd;
		}		
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;


		let warehouseListToUse = warehouseCdList.filter(value => (value.logicCenter === defaults.logicCenter
			&& (value.materialYn === 'Y' || value.goodsYn === 'Y' || value.productYn === 'Y' )
		));
		if(!validateString(headerData.warehouseCd) && warehouseListToUse.length > 0)	{
			defaults.warehouseCd = warehouseListToUse[0].warehouseCd;
		}

		// productEmp가 있으면 productEmp을 사용, 없으면 orderEmp을 사용, 둘 다 없으면 employeeCdList[0].empNo를 사용
		defaults.orderEmp = headerData.productEmp ? headerData.productEmp : headerData.orderEmp ? headerData.orderEmp : '';
		defaults.orderEmpNm = headerData.productEmpNm ? headerData.productEmpNm : headerData.orderEmpNm ? headerData.orderEmpNm : '';

		defaults.badQty = headerData.badQty ? headerData.badQty : 0;
		defaults.productQty = headerData.productQty ? headerData.productQty : 0;
	
		return defaults;
	}, [selectedPRD3010_R01, compCdList, workPlaceList, employeeCdList, wmsCdList, warehouseCdList])

	const handleFetchBomProductList = useCallback(async ( itemCd: string, outWarehouseCd: string, logicCenter: string ) => {

		const responseData = (await getPRD3010_R01DetailStockList(itemCd, outWarehouseCd, logicCenter)).data.data;
		if(responseData && responseData.length > 0){

			//PRD3010_R01DetailList와 responseData를 비교해서
			//lotNo, childItemcd(itemCd)가 같으면 warehouseCd, logicCenter, lotQty를 업데이트
			const currentDetailList = usePRD3010_R01Store.getState().PRD3010_R01DetailList;
			const updatedDetails = currentDetailList.map((value) => {
				const response = responseData.find(response => 
					response.lotNo === value.lotNo && response.childItemcd === value.childItemcd
				);
				return {
					...value,
					warehouseCd: value.warehouseCd === outWarehouseCd ? outWarehouseCd : warehouseCdList[0].warehouseCd,
					warehouseNm: response ? response.warehouseNm : warehouseCdList[0].warehouseNm,
					logicCenter: value.logicCenter === logicCenter ? logicCenter : wmsCdList[0].minorCd,
					lotQty: response ? response.lotQty : 0,
				}
			});

			setPRD3010_R01DetailList(updatedDetails);
		}
		setOriginalPRD3010_R01DetailList(responseData);
		detailGridRef.current?.api.ensureIndexVisible(0, 'top');
		setMessage(`상세내역 ${responseData.length}건을 조회하였습니다.`);
		setTimeout(() => setMessage(""), 5000);


	}, [editPRD3010_R01?.itemCd, editPRD3010_R01?.warehouseCd, editPRD3010_R01?.logicCenter])

	const fetchDetailList = useCallback(async (itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string) => {
		const response = await getPRD3010_R01DetailList(itemCd, productQty, badQty, outWarehouseCd, logicCenter);
			
		if (response.data && response.data.successFlag === false) {
			showWarning(response.data.message);
			setPRD3010_R01DetailList([]);
			return;
		}

		const responseData = response.data.data;

		let updatedDetailList: PRD3010_R01DetailDto[] = [];
		if(responseData && responseData.length > 0){
			updatedDetailList = responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
				lotQty: value.lotQty ?? 0,
				transportQty: 0,
				transportedQty: 0,
			}));
			setPRD3010_R01DetailList(updatedDetailList);
			setOriginalPRD3010_R01DetailList(responseData);
			setDetailScrollTop(null);
			setTimeout(() => setMessage(""), 5000);
		}else{
			// showError('상세내역이 없습니다.');
			// 자재출고 내역은 데이터가 없으면 보여주지 말기
			setPRD3010_R01DetailList([]);
		}

		return;
	}, [setPRD3010_R01DetailList, setOriginalPRD3010_R01DetailList, setDetailScrollTop, setMessage]);

	//생산결과가 있는 작업지시 정보 조회
	const fetchProductResult = useCallback(async (headerData: PRD3010_R01HeaderDto) => {

		let apiHeaderData: PRD3010_R01ProductResultDto | null = null;
		try {
			const transportResponse = await getPRD3010_R01ProductResultList(headerData.productOrderNo!);
			apiHeaderData = transportResponse.data.data;
			
			let baseDataForDefaults;
			if (apiHeaderData && apiHeaderData.productResultNo) {
				setProductResultComplete(true);
				baseDataForDefaults = { 
					...defaultPRD3010_R01HeaderRow(),
					...headerData,
					...apiHeaderData,
					orderQty: headerData.orderQty - headerData.resultQty,
					productQty : 0,
					badQty : 0, // 불량수량 0 고정(초기화)
					itemStatus: apiHeaderData.itemStatus ? apiHeaderData.itemStatus : itemStatusList[0]?.minorCd ?? '',
				};
			} else {
				setProductResultComplete(false);
				baseDataForDefaults = { 
					...defaultPRD3010_R01HeaderRow(),
					...headerData,
				};
			}
			

			const defaultValues = handleProductResultInfoCode(baseDataForDefaults);

			setEditPRD3010_R01({	
				...baseDataForDefaults,
				...defaultValues,
			});

		} catch (error) {
			console.error("ProductResult 내역 조회 실패:", error);
			setProductResultComplete(false);
		}

		if(apiHeaderData && apiHeaderData.productResultNo) {
			return apiHeaderData;
		} else {
			return null;
		}
	}, [setProductResultComplete, defaultPRD3010_R01HeaderRow, itemStatusList, handleProductResultInfoCode, setEditPRD3010_R01]);

	const handleFetchLotList = useCallback(() => {
		if (!detailFetchTrigger) return;
		
		setDetailScrollTop(null);
		setLotScrollTop(null);
		setInspectScrollTop(null);
		setPRD3010_R01LotList([]);
		setPRD3010_R01DetailList([]);
		setPRD3010_R01InspectList([]);

		const fetchAllData = async () => {
			if (selectedPRD3010_R01) {

				const headerData = await fetchOne();
				if(!headerData) return;

				const productResult: PRD3010_R01ProductResultDto | null = await fetchProductResult(headerData);
				if(productResult && productResult.productResultNo !== '') {

					await fetchDetailList(
						productResult?.itemCd || '',
						productResult?.productQty ?? 0,
						productResult?.badQty ?? 0,
						headerData.outWarehouseCd,
						headerData.logicCenter
					);
				}else{
					await fetchDetailList(
						headerData?.itemCd || '',
						0,
						0,
						headerData.outWarehouseCd,
						headerData.logicCenter
					);

				}

				//  header의 창고정보, 물류정보를 정의해서 자재출고 항목에 창고정보, 물류정보를 업데이트
				if (productResult && productResult.productResultNo !== '') {

					await handleFetchBomProductList(
						productResult.itemCd,
						headerData.outWarehouseCd,
						productResult.logicCenter || (editPRD3010_R01?.logicCenter ?? wmsCdList[0].minorCd)
					);
				}
				const lotRow = defaultPRD3010_R01LotRow();
				if (lotRow.inserted) {
					insertPRD3010_R01LotList([{ ...lotRow }]); // 소요량 계산 유도
				}
				setPRD3010_R01InspectList([]);
				const inspectRow = defaultPRD3010_R01InspectRow();
				if (inspectRow.inserted) {
					insertPRD3010_R01InspectList([{ ...inspectRow }]);
				}
			}
		};

		fetchAllData();
		setDetailFetchTrigger(false);

	}, [
		selectedPRD3010_R01, detailFetchTrigger, setDetailFetchTrigger,
		fetchOne, fetchProductResult, fetchDetailList,
		setPRD3010_R01LotList, setPRD3010_R01DetailList, setPRD3010_R01InspectList,
		handleFetchBomProductList, editPRD3010_R01, wmsCdList,
		insertPRD3010_R01LotList, defaultPRD3010_R01LotRow,
		insertPRD3010_R01InspectList, defaultPRD3010_R01InspectRow,
		setDetailScrollTop, setLotScrollTop, setInspectScrollTop,
	]);

	

	useEffect(() => {
		setPRD3010_R01Filter({ labelPrintAuto: defaultLabelPrintAuto });
	}, [defaultLabelPrintAuto, setPRD3010_R01Filter]);
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultPRD3010_R01HeaderRow,
		defaultPRD3010_R01LotRow,
		defaultPRD3010_R01DetailRow,
		defaultPRD3010_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleFetchBomProductList,
		handleFetchLotList,
	};
}
